// extracted by mini-css-extract-plugin
export default {"button":"SubscribeVacancy_button__reJ-Z","form":"SubscribeVacancy_form__ypls2","formCaption":"SubscribeVacancy_formCaption__CU8zR","formLink":"SubscribeVacancy_formLink__7BJ5h"};